<template>
  <div class="sigle-bottom-btn">
    <van-button type="info"
                style="height: 40px; line-height: 40px"
                @click="clickBtn"
                round
                :loading="loading"
                :loading-text="loadingText"
                size="large">
      <slot></slot>
    </van-button>
  </div>
</template>
<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    loadingText: {
      type: String,
      default: '加载中',
    }
  },
  name: 'SingleBottomBtn',
  data () {
    return {
    }
  },

  methods: {
    clickBtn () {
      this.$emit('clickBtn')
    }
  }
}
</script>
<style scoped lang="less">
.sigle-bottom-btn {
  height: 110px;
  line-height: 110px;
  background: #000;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 2px 21px 0px rgba(186, 186, 186, 0.44);
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 0 100px;
}
</style>
